import {
    PROJECTS_CRUD_RESTORE_STATE,
    APPTOOLBAR_RESET_APP_STATE,
    PIPE_CONSTRAINTS_SET_DEFAULTS,
    PIPE_CONSTRAINTS_SET_MINIMUMS,
    PIPE_CONSTRAINTS_SET_MAXIMUMS,
    PIPE_SWITCH_THERMOPLASTIC_LINTER,
    STONE_BED_SET_SEPARATION_DISTANCE,
    PIPE_GLOBALS_SET_SCALE_VALUE,
    PIPE_GLOBALS_SET_SCALE_PIXELS,
    PIPE_CALCULATIONS_SET_PARAMETER_VALUE,
    DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE,
    CONTEXT_SELECTED_PIPE_ELEMENT,
    CONTEXT_DESELECTED_PIPE_ELEMENT,
    SUB_PROJECTS_CRUD_RESTORE_STATE,
    MULTIBED_RESET_APP_STATE,
    APPTOOLBAR_BASIC_RESET_APP_STATE,
    GLOBAL_CHAMBER_PLAN_SCALE_IN,
    GLOBAL_CHAMBER_PLAN_SCALE_MT, GLOBAL_PIPE_PLAN_SCALE_IN, GLOBAL_PIPE_PLAN_SCALE_MT,
} from "../lib/types";

import PipeDataset, { PipeFlowDirection, pipeFittings, pipeSizes, pipeSystemTypes, pipeTypes } from "../lib/pipe-dataset";
import pipeSelectors from "../lib/pipe-selectors";

const defaultDiameter = pipeSizes.default;

const corner = PipeDataset.pipeParts[0];
const manifoldT = PipeDataset.pipeParts[1];

const initialState = {
    minimums: {},
    maximums: {},
    pipeNominalDiameter: defaultDiameter,
    pipeType: pipeTypes.default,
    pipeFitting: pipeFittings.default,
    pipeFlowDirection: PipeFlowDirection.TopRightToBottomLeft,
    pipeParts: {
        corner: corner,
        manifoldT: manifoldT,
    },
    pipeSystemType: pipeSystemTypes.default,
    pipeRequiredVolume: 0,
    pipeAvailableWidth: 30,
    pipeAvailableLength: 20,
    pipeStoneAbove: 6,
    pipeStoneBelow: 4,
    pipeStonePorosity: 40,
    pipeInvertElevation: 10,
    thermoplasticLiner: false,
    pipePerimeterOffset: defaultDiameter.perimeterOffset.default.in,
    contextSelectedPipeElement: null,
    scalePixels: 300,
    scaleValue: 20,
    planScaleInches: 1,
    planScaleMts: 350,
};

const PipeGlobals = ( state = initialState, action ) => {
    switch (action.type) {

        case CONTEXT_SELECTED_PIPE_ELEMENT:
            return {
                ...state,
                contextSelectedPipeElement: action.payload,
            };

        case CONTEXT_DESELECTED_PIPE_ELEMENT:
            return {
                ...state,
                contextSelectedPipeElement: null,
            };

        case PIPE_SWITCH_THERMOPLASTIC_LINTER:
            return {
                ...state,
                thermoplasticLiner: !state.thermoplasticLiner,
            };

        case PIPE_CONSTRAINTS_SET_MINIMUMS:
            return {
                ...state,
                minimums: action.payload,
            };

        case PIPE_CONSTRAINTS_SET_MAXIMUMS:
            return {
                ...state,
                maximums: action.payload,
            };

        case PIPE_CONSTRAINTS_SET_DEFAULTS:
            const {
                pipeNominalDiameter,
                pipeFitting,
                pipeType,
                pipeSystemType,
                pipeRequiredVolume,
                pipeAvailableWidth,
                pipeAvailableLength,
                pipeStoneAbove,
                pipeStoneBelow,
                pipeStonePorosity,
                pipeInvertElevation,
                pipeRowSpacing,
                pipePerimeterOffset,
            } = action.payload;
            const defaults = {
                pipeNominalDiameter,
                pipeFitting,
                pipeType,
                pipeSystemType,
                pipeRequiredVolume,
                pipeAvailableWidth,
                pipeAvailableLength,
                pipeStoneAbove,
                pipeStoneBelow,
                pipeStonePorosity,
                pipeInvertElevation,
                pipeRowSpacing,
                pipePerimeterOffset,
            };

            return Object.keys(defaults).reduce(( previousState, defaultParameter ) => {
                return setParameterValue(previousState, defaultParameter, defaults[defaultParameter]);
            }, state);

        case PIPE_GLOBALS_SET_SCALE_PIXELS:
            return {
                ...state,
                scalePixels: action.payload,
            };

        case PIPE_GLOBALS_SET_SCALE_VALUE:
            return {
                ...state,
                scaleValue: action.payload,
            };

        case PIPE_CALCULATIONS_SET_PARAMETER_VALUE:
            return setParameterValue(
                state,
                action.payload.parameter,
                action.payload.value,
            );

        case DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE:
            return setParameterValue(
                state,
                "pipeRowSpacing",
                action.payload,
            );

        case STONE_BED_SET_SEPARATION_DISTANCE:
            return setParameterValue(
                state,
                "pipePerimeterOffset",
                action.payload.sepDistance,
            );

        case MULTIBED_RESET_APP_STATE:
            const nState = {
                ...initialState,
                pipeStoneBelow: state.pipeNominalDiameter.rawPipeND < 30 ? 4 : 6,
                pipePerimeterOffset: state.pipeNominalDiameter.perimeterOffset.default.in,
                pipeNominalDiameter: state.pipeNominalDiameter,
                scalePixels: state.scalePixels,
                scaleValue: state.scaleValue,
                planScaleInches: ( state.planScaleInches ) ? state.planScaleInches : 1,
                planScaleMts: ( state.planScaleMts ) ? state.planScaleMts : 350,
            };

            return {
                ...nState,
                pipeAvailableWidth: pipeSelectors.stoneBedMinimumWidth({ pipeGlobals: nState }),
                pipeAvailableLength: pipeSelectors.stoneBedMinimumLength({ pipeGlobals: nState }),
            };

        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            const newState = {
                ...initialState,
                pipeStoneBelow: state.pipeNominalDiameter.rawPipeND < 30 ? 4 : 6,
                pipePerimeterOffset: state.pipeNominalDiameter.perimeterOffset.default.in,
                pipeNominalDiameter: state.pipeNominalDiameter,
            };

            return {
                ...newState,
                pipeAvailableWidth: pipeSelectors.stoneBedMinimumWidth({ pipeGlobals: newState }),
                pipeAvailableLength: pipeSelectors.stoneBedMinimumLength({ pipeGlobals: newState }),
            };

        case SUB_PROJECTS_CRUD_RESTORE_STATE:
            /* receive the new state */
            let srState = action.payload.pipeGlobals;
            /* if no pipe state present, return default state */
            if (!srState || !srState.pipeFitting || !srState.pipeType || !srState.pipeSystemType) {
                return initialState;
            }
            /* instantiate serialized data */
            srState = {
                ...srState,
                pipeNominalDiameter: PipeDataset.pipeSizes
                    .find(( p ) => p.pipeND.in === srState.pipeNominalDiameter._pipeND._inches),
                pipeType: PipeDataset.pipeTypes
                    .find(( p ) => p.id === srState.pipeType._id),
                pipeFitting: PipeDataset.pipeFittings
                    .find(( p ) => p.id === srState.pipeFitting._id),
                pipeParts: initialState.pipeParts,
                pipeSystemType: PipeDataset.pipeSystemTypes
                    .find(( p ) => p.id === srState.pipeSystemType._id),
                scalePixels: state.scalePixels,
                scaleValue: state.scaleValue,
                planScaleInches: ( state.planScaleInches ) ? state.planScaleInches : 1,
                planScaleMts: ( state.planScaleMts ) ? state.planScaleMts : 350,
            };
            /* return state */
            return srState;

        case PROJECTS_CRUD_RESTORE_STATE:
            /* receive the new state */
            let rState = action.payload.pipeGlobals;
            /* if no pipe state present, return default state */
            if (!rState || !rState.pipeFitting || !rState.pipeType || !rState.pipeSystemType) {
                return initialState;
            }
            /* instantiate serialized data */
            rState = {
                ...rState,
                pipeNominalDiameter: PipeDataset.pipeSizes
                    .find(( p ) => p.pipeND.in === rState.pipeNominalDiameter._pipeND._inches),
                pipeType: PipeDataset.pipeTypes
                    .find(( p ) => p.id === rState.pipeType._id),
                pipeFitting: PipeDataset.pipeFittings
                    .find(( p ) => p.id === rState.pipeFitting._id),
                pipeParts: initialState.pipeParts,
                pipeSystemType: PipeDataset.pipeSystemTypes
                    .find(( p ) => p.id === rState.pipeSystemType._id),
            };
            /* return state */
            return rState;

        case GLOBAL_PIPE_PLAN_SCALE_IN:

            console.log("pipe planScaleInches state", state);

            return {
                ...state,
                planScaleInches: action.payload,
            };

        case GLOBAL_PIPE_PLAN_SCALE_MT:

            console.log("pipe planScaleMts state", state);

            return {
                ...state,
                planScaleMts: action.payload,
            };


        default:
            return state;
    }
};

// a copy of pipe-globals-reducer.js setParameterValue() on system-parameters-reducer
// this is the original
// TODO this should be on its util file
const setParameterValue = ( currentState, parameter, value ) => {
    switch (parameter) {
        case "pipeNominalDiameter":
            return {
                ...currentState,
                pipeStoneAbove: 6,
                pipeStoneBelow: value.rawPipeND < 30 ? 4 : 6,
                pipePerimeterOffset: value.perimeterOffset.default.in,
                [parameter]: value,
            };
        case "pipeStoneAbove":
        case "pipeStoneBelow":
        case "pipeFitting":
        case "pipeType":
        case "pipeSystemType":
        case "pipeRequiredVolume":
        case "pipeAvailableWidth":
        case "pipeAvailableLength":
        case "pipeFlowDirection":
        case "pipeStonePorosity":
        case "pipeInvertElevation":
        case "pipeRowSpacing":
        case "pipePerimeterOffset":
            return {
                ...currentState,
                [parameter]: value,
            };
        default:
            console.warn(`${parameter} is not a pipe global`);
    }

    return currentState;
};

export default PipeGlobals;



// WEBPACK FOOTER //
// ./src/reducers/pipe-globals-reducer.js